import {
  Checkbox,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  HTMLElementTypeEnum,
  Switch,
  SwitchColorEnum,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { SegmentsCardBulkActions } from '@/features/segments/components/SegmentsCardBulkActions';
import { useSelectedItemsStore } from '@/stores/selected-items';

import { TClip } from '../../types';
import { ClipSponsorshipReportButton } from '../ClipSponsorshipReportButton/ClipSponsorshipReportButton';

type TTracingListHeaderResult = {
  items: TClip[];
  className?: string;
};
export function ClipBodyCardHeader({ items, className }: TTracingListHeaderResult) {
  const { t } = useTranslation();
  const store = useSelectedItemsStore();
  const { compactUis, setCompactUis } = useBroadcastScheduleProgram();

  const handleCheckboxChange = () => {
    if (store.toggleAllActived) {
      store.dispatch({ type: 'removeToggleAll' });
      store.dispatch({ type: 'resetIds' });
    } else {
      store.dispatch({
        type: 'toggleAll',
      });
      store.dispatch({
        type: 'include',
        payload: items.map(item => item.id) as string[],
      });
    }
  };

  return (
    <div
      className={clsx(
        'sticky top-0 z-10 flex min-w-[120px] items-center justify-between gap-4 bg-white py-2',
        className
      )}
      data-testid="tracing-list-header"
    >
      <div className="flex items-center gap-2">
        <Checkbox
          onChange={handleCheckboxChange}
          indeterminate={
            store.include.length > 0 &&
            store.include.length < items.length &&
            !store.toggleAllActived
          }
          checked={
            store.toggleAllActived ||
            (store.include.length === items.length && store.include.length > 0 && items.length > 0)
          }
          disabled={items?.length === 0}
        >
          {items.length === 0 ? (
            <Typography
              fontSize={FontSizeEnum.Basic}
              weight={FontWeightEnum.Regular}
              color={FontColorEnum.Dark10}
            >
              {t('Sin resultados')}
            </Typography>
          ) : items.length === 1 ? (
            <>
              <Typography
                fontSize={FontSizeEnum.Basic}
                weight={FontWeightEnum.Regular}
                color={FontColorEnum.Dark10}
              >
                {t('1 Resultado')}
              </Typography>
            </>
          ) : (
            <>
              <Typography
                fontSize={FontSizeEnum.Basic}
                weight={FontWeightEnum.Semibold}
                color={FontColorEnum.Dark10}
              >
                {store.toggleAllActived
                  ? `${items?.length} / `
                  : store.include.length !== 0 && `${store.include.length} / `}
              </Typography>
              {items?.length < 10000 ? (
                <>
                  <Typography
                    element={HTMLElementTypeEnum.Span}
                    fontSize={FontSizeEnum.Basic}
                    weight={FontWeightEnum.Bold}
                    color={FontColorEnum.Dark10}
                  >
                    {items?.length}
                  </Typography>
                  <Typography
                    element={HTMLElementTypeEnum.Span}
                    fontSize={FontSizeEnum.Basic}
                    weight={FontWeightEnum.Regular}
                    color={FontColorEnum.Dark10}
                  >
                    {' '}
                    {t('Resultados')}
                  </Typography>
                </>
              ) : (
                <Typography
                  fontSize={FontSizeEnum.Basic}
                  weight={FontWeightEnum.Regular}
                  color={FontColorEnum.Dark10}
                >
                  10.000+
                </Typography>
              )}
            </>
          )}
        </Checkbox>
        <SegmentsCardBulkActions clips />
        <ClipSponsorshipReportButton />
      </div>

      {items && items.length > 0 && (
        <Switch
          checked={compactUis}
          onChange={() => setCompactUis(prev => !prev)}
          endLabel={t('Compacto')}
          color={SwitchColorEnum.SUCCESS}
        />
      )}
    </div>
  );
}
